import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";

import "./es-polyfills";
import { withPageTracking } from "./hoc";
import store, { history } from "./store";
import App, { AppProps } from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route component={withPageTracking<AppProps>(App)} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root") as HTMLElement,
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx